module.exports = __webpack_public_path__ + "static/img/product03.41391ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product03.png
// module id = i2YF
// module chunks = 1